import { render, staticRenderFns } from "./module-header.vue?vue&type=template&id=6763f6ab"
import script from "./module-header.vue?vue&type=script&lang=js"
export * from "./module-header.vue?vue&type=script&lang=js"
import style0 from "./module-header.vue?vue&type=style&index=0&id=6763f6ab&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports